import React, { useEffect, useState } from 'react'
import './DynamicServiceComponent.scss'
import ServicesList from './ServicesList';
import imagesList from './ImagesList';

const DynamicServiceComponent = ({service}) => {
  const [imageSrc, setImageSrc] = useState(null);
  const ServiceType = ServicesList[service]

  useEffect(() => {
    const loadImage = async () => {
      if (imagesList[service]) {
        const { default: loadedImage } = await imagesList[service]();
        setImageSrc(loadedImage);
      } else{
        setImageSrc('')
      }
    };
    loadImage();
  }, [service]);

  return (
    <main className='DynamicServiceComponent'>
      {ServiceType && imageSrc &&
        <>
          <h1>{ServiceType?.service_name}</h1>
          <section className='ImgPara'>
            {imageSrc && <img src={imageSrc} alt={service} draggable={false}/>}
            <p>{ServiceType?.service_desecripiton}</p>
          </section>
          <h2>{service === 'research-development' ? 'Main Lines of Research' : service === 'waste-management' ? 'Our Waste Management Practices' : 'Services Offered'}</h2>
          <section className='ServicesOffered'>
            {ServiceType?.services_offered && ServiceType?.services_offered.map((data, index) => (
              <article key={index}>
                <span>{data && index + 1}</span>
                <div>
                  <p><b>{data && data?.sub_service_name}</b> {data && data?.sub_service_description}</p>
                  {data?.subcategory &&
                    <ul>
                      {data?.subcategory && data?.subcategory.map((subdata, index) => (
                        <li key={index}>
                          <b>{subdata && subdata?.sub_category_name}{" "}</b>
                          {subdata && subdata?.sub_category_description}
                          {subdata && subdata?.super_sub_category &&
                            <ul>
                              {subdata?.super_sub_category?.map((supersubdata, index) => (
                                <li key={index}>{supersubdata && supersubdata?.super_sub_category_name}</li>
                              ))}
                            </ul>
                          }
                        </li>
                      ))}
                    </ul>
                  }
                </div>
              </article>)
              )
            }
          </section>
          {service === 'research-development' &&
            <>
              <h2>Contract Research</h2>
              <ul className='UL'>
                <li>Client-Specific Research Analysis and Product Development</li>
                <li>Cytotoxicity and Genotoxicity Analysis</li>
                <li>Biological Agents for Vector Control Studies</li>
                <li>Synthesis and Characterization of Metallic Nanoparticles</li>
                <li>Repurposing Existing Drugs and Novel Therapeutic Compounds</li>
                <li>Bioformulations for Vector Control</li>
                <li>Nano-based Metallic Particles and Oxides</li>
                <li>Biodegradation Studies</li>
              </ul>
            </>
          }
          {service === 'clinical-biochemistry' &&
            <ul className='UL'>
              <li>Analysis of Industrial exposure to lead Blood [lead] Industrial exposure to pesticides by Plasma cholinesterase activity.</li>
              <li>Malnutrition Plasma [albumin] and/or [pre-albumin] analysis.</li>
              <li>Thyroid dysfunctionPlasma [TSH] and/or [thyroxine].</li>
              <li>Clinical trials of new therapeutic agents.</li>
              <li>Biochemical investigations can be done for diagnosis and prognosis of diabetes mellitus, jaundice, myocardial infarction, gout, pancreatitis, rickets, cancers, acid-base imbalance, etc. Infectious disease like Cholera, Dengue and Malaria analysis will be done.</li>
              <li>Successful medical treatment is unimaginable without the service of a clinical biochemistry laboratory.</li>
            </ul>
          }
          <section className='LabPractice'>
            <span>All the laboratory works are carried out by following SOPs</span>
          </section>
        </>
      }
    </main>
  )
}

export default DynamicServiceComponent